module.exports = __webpack_public_path__ + "media/images/pages/fig_dataPopulation_01-70594b898de0b41a33860c7e373934a1.png";